module.exports = __webpack_public_path__ + "static/project-12c-ee5c813a9107596aa0ed4534687ad975.png";